<template>
  <div style="height: 100vh;">
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <sticky v-if="origin" class="page-header sticky-page-header page-header--new" :back-button="true">
       <span slot="left-title">
        <h1 class="title is-3 is-inline-block">
          <router-link :to="{name: 'OriginList'}" class="has-text-black is-uppercase">Origines /</router-link>
          <span class="has-text-weight-medium has-text-grey is-uppercase">{{origin.name}}</span>
        </h1>
      </span>

      <router-link :to="{name: 'Multidiffusion'}"
        class="dropdown-item" slot="dropdown-content"
      >
        <span class="icon"><i class="fas fa-chart-bar"></i></span>
        <span>Suivi statistique</span>
      </router-link>
      <router-link v-if="!origin.parent" :to="{name: 'OriginCreate', query: {'parent': origin.pk}}"
        class="dropdown-item" slot="dropdown-content"
      >
        <span class="icon"><i class="fas fa-plus-circle"></i></span>
        <span>Ajouter une Sous Origine</span>
      </router-link>
      <router-link :to="{name: 'OriginEdit', params: {id: origin.pk}}" 
        class="dropdown-item" slot="dropdown-content" 
      >
        <span class="icon"><i class="fas fa-edit"></i></span>
        <span>Editer</span>
      </router-link>
      <a @click.prevent.stop="beforeRemove" class="dropdown-item has-text-danger"
          slot="dropdown-content">
        <span class="icon"><i class="fas fa-trash-alt"></i></span><span>Supprimer origine</span>
      </a>
    </sticky>
    <div v-if="origin" class="columns is-gapless is-padding-left-on-btn-actions is-padding-right-on-btn-actions is-padding-top">
      <div class="column is-8 is-padding-right">
        <div class="has-bg-white is-border">
          <div class="columns is-multiline">
            <div class="column is-12 is-padding">
              <h2 class="is-size-4">
                <strong>Sous origines</strong>
                <span style="position: relative;" v-helper.bottom="'5nd2xV7Enm8qQe0o6aOkoA'">
                  <i class="fal fa-question-circle has-text-grey is-size-6 is-margin-left-xsmall"></i>
                </span>
              </h2>
              <div class="lignes-origines is-padding-top">
                <div v-for="(child, idx) in children" :key="idx"
                    @click.prevent.stop="openChild(child)"
                    :class="{'is-opened': currentChild && currentChild.pk === child.pk}"
                    class="ligne-origine is-border-top is-border-left is-border-right is-margin-bottom">
                  <div class="columns is-border-bottom is-vcentered">
                    <div class="column">
                      {{child.name}}&nbsp;&nbsp;<span v-if="child.multidiffusion"
                                                      class="tag is-info is-xsmall">Multidiffusion</span>
                      <br>
                      <span class="is-size-6 has-text-grey" v-if="child.monthly_costs.length > 0">Répartie sur {{child.monthly_costs.length}} mois</span>
                    </div>
                    <div class="column is-narrow is-uppercase is-size-7 is-paddingless-left on-hover">
                      <a>Voir</a>
                    </div>
                    <div class="column is-narrow is-uppercase is-size-7 is-paddingless-left on-hover">
                      <router-link :to="{name: 'OriginEdit', params: {id: child.pk}}">Editer</router-link>
                    </div>
                    <div class="column is-narrow is-uppercase is-size-7 is-paddingless-left on-hover">
                      <a @click.prevent.stop="removeMonthlyCost(child)">Supprimer</a>
                    </div>
                  </div>
                  <div v-if="child.monthly_costs.length > 0"
                      class="origine-detail is-border-bottom has-text-grey is-padding-top-small">
                    <div class="columns is-size-6" v-for="(mCost, idx) in child.monthly_costs">
                      <div class="column is-paddingless-top is-padding-bottom-small">{{mCost.month - 1 | monthName}}
                        {{mCost.year}}
                      </div>
                      <div
                        class="column is-narrow is-paddingless-top is-padding-bottom-small">
                        Coût : {{mCost.cost | prettyPrice}} {{$currency}}
                      </div>
                      <div
                        class="column is-narrow is-paddingless-top is-padding-bottom-small">
                        Différentiel : <span v-if="mCost.margin">{{mCost.margin | prettyPrice}} {{$currency}}</span>
                        <span v-else>--</span>
                      </div>
                    </div>
                  </div>
                  <div v-else
                    class="origine-detail is-border-bottom has-text-grey is-padding-top-small"
                  >
                    <div class="is-padding-left is-padding-bottom-small"><i class="is-size-7">Pas de coûts déclaré.</i></div>
                  </div>
                </div>

                <div @click="goToOriginCreate" class="add-origine is-border columns is-border-dashed bloc-add">
                  <div class="column is-uppercase">Ajouter une sous origine</div>
                  <div class="column is-narrow">
                    <span class="">
                      <i class="fal fa-plus-square"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-4 is-3-fullhd">
        <div class="is-border">
          <div class="columns is-column">
            <!-- <div class="column is-narrow is-paddingless is-tab-like is-border-bottom columns is-gapless is-vcentered"> -->
              <div class="column has-bg-light-darken-1 is-size-4">
                <strong class="is-padding-left-small is-padding-right-small">Coûts mensuels</strong>
              </div>
              <!-- <div class="column" style="min-height: 50px">
                <a class="button is-white is-min-width-0 is-padding-left-small is-padding-right-small">
                  <span class="icon is-small">
                      <i class="fal fa-search"></i>
                  </span>
                </a>
                <a class="button is-white is-min-width-0 is-padding-left-small is-padding-right-small">
                  <span class="icon is-small">
                      <i class="fal fa-filter"></i>
                  </span>
                </a>
              </div> -->
            <!-- </div> -->

            <ul class="column is-paddingless liste-couts has-bg-white">
              <li v-for="(costs, year, i) in orderedCosts">
                <div
                  class="columns is-paddingless is-vcentered column is-12 has-text-grey has-bg-light is-size-7 is-border-bottom"
                  :class="{'is-border-top': i > 0}"
                >
                  <div class="column is-padding-top-small is-padding-bottom-small"><strong>{{year}}</strong></div>
                  <!--<div class="column is-padding-top-small is-padding-bottom-small"><span
                    class="tag is-primary is-pulled-right is-xsmall">{{costs.length}} mois</span></div>-->
                </div>
                <ul>
                  <li v-for="c, index in costs" class="column"
                    :class="{'is-border-bottom': index < costs.length - 1}"
                  >
                    {{(Number(c.month) - 1 ) | monthName }} {{c.year}}
                    <div class="columns is-gapless has-text-grey is-size-6">
                      <div class="column">Coût total : {{c.cost | prettyPrice}} {{$currency}}</div>
                      <div class="column is-narrow has-text-right" v-if="c.margin">Différentiel : {{c.margin | prettyPrice}} {{$currency}}
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import OriginForm from '@/components/origin/OriginForm'
  import { sortBy } from 'lodash'

  export default {
    name: 'OriginVue',
    components: {
      OriginForm
    },
    data () {
      return {
        entry: null,
        loading: false,
        parent: null,
        origin: null,
        currentChild: null
      }
    },
    watch: {
      '$route': 'getOrigin'
    },
    computed: {
      children () {
        return sortBy(this.origin.children, 'name')
      },
      originPk () {
        return this.$route.params.id
      },
      orderedCosts () {
        let costs = {}
        this.origin.monthly_costs.forEach(x => {
          let year = x.year
          if ((year in costs) === false) {
            costs[year] = []
          }
          costs[year].push(x)
          costs[year] = sortBy(costs[year], 'month')
        })

        return costs
      }
    },
    methods: {
      beforeRemove () {
        if (this.origin.protected) {
          this.$notify({
            type: 'is-danger',
            text: 'Cette origine est liée à vos Multidiffusions et/ou Sites Publics, suppression impossible.'
          })
        } else {
          this.$swal({
            title: 'Suppression origine',
            text: 'Souhaitez-vous vraiment supprimer cette origine ?',
            confirmButtonText: 'Oui',
            cancelButtonText: 'Annuler',
            cancelButtonColor: '#363636',
            showCloseButton: true
          }).then(res => {
            console.log(res)
            if (res.value) {
              this.removeOrigin()
            }
          })
        }
      },
      goToOriginCreate () {
        this.$router.push({name: 'OriginCreate', query: {'parent': this.origin.pk}})
      },
      openChild (child) {
        this.currentChild = child
      },
      removeMonthlyCost (child) {
        this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer cet élément ?',
          confirmButtonText: 'Supprimer'
        }).then(r => {
          if (r.value) {
            this.$api.originService.delete(child.pk)
              .then(res => {
                this.$notify({
                  type: 'is-success',
                  text: 'Élément supprimé.'
                })
                this.getOrigin()
              })
              .catch(err => {
                console.log(err)
                this.$notify({
                  type: 'is-danger',
                  text: 'Impossible de supprimer cet élèment.'
                })
              })
          }
        })
      },
      submitFailed (origin) {
        console.log('error with origin > ', origin)
      },
      submit (origin) {
        this.$api.originService.put(origin.pk, origin)
          .then(res => {
            this.$notify({
              type: 'is-success',
              text: 'Mise à jour effectuée.'
            })
            this.$router.push({name: 'OriginVue', params: {id: origin.pk}})
          })
          .catch(err => {
            console.log(err)
            this.$notify({
              type: 'is-danger',
              text: 'Erreur lors de l\'enregistrement.'
            })
          })
      },
      removeOrigin () {
        this.$api.originService.delete(this.originPk)
          .then(res => {
            this.$notify({
              type: 'is-success',
              text: 'Suppression effectuée'
            })
            this.getOrigins()
            this.$router.push({name: 'OriginList'})
          })
          .catch(() => {
            this.$notify({
              type: 'is-danger',
              text: 'Impossible de supprimer cet élément'
            })
          })
      },
      getOrigins () {
        this.$api.originService.get().then(r => {
          this.$store.commit('setOrigins', {origins: r.data})
        })
      },
      getOrigin () {
        this.loading = true
        this.origin = null
        this.$api.originService.getOne(this.originPk).then(res => {
          this.loading = false
          this.origin = res.data
          if (this.origin.parent) {
            this.getParentOrigin(this.origin.parent)
          }
        }).catch(() => {
          this.loading = false
        })
      },
      getParentOrigin (id) {
        this.$api.originService.getOne(id)
          .then(res => {
            this.parent = res.data.parent
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    created () {
      this.getOrigin()
      this.$scrollTo('#app', 0)
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/origin/OriginVue.vue